"use strict";
'use client';
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var SVG = function (_a) {
    var title = _a.title, titleId = _a.titleId, props = __rest(_a, ["title", "titleId"]);
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", viewBox: "0 0 21.337 32", preserveAspectRatio: "xMidYMid meet", "aria-labelledby": titleId }, props),
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("path", { className: "snapchat_svg__st0", d: "M10.882 6.1c.839 0 3.726.225 5.087 3.276.448 1.004.333 2.824.241 4.287-.016.255-.032.509-.045.764l.062.069c.025.028.258.271.776.291h.017c.342-.013.728-.119 1.148-.316a.555.555 0 01.23-.043c.099 0 .204.019.291.055l.013.005c.22.077.375.222.378.353.001.075-.055.342-.833.649-.076.03-.176.062-.292.099-.507.161-1.272.404-1.53 1.011-.145.343-.106.746.118 1.2.092.215 1.538 3.474 4.794 4.01a.171.171 0 01-.013.052c-.055.13-.406.579-2.588.916-.342.053-.425.435-.523.88-.035.159-.071.32-.12.486-.015.05-.018.053-.072.053h-.025c-.563 0-1.118-.188-1.689-.188-.302 0-.614.026-.926.078-.668.111-1.211.495-1.786.902-.772.546-1.571 1.11-2.789 1.11-.057 0-.114-.002-.171-.005a1.23 1.23 0 01-.105.005c-1.218 0-2.017-.564-2.789-1.11-.575-.407-1.119-.791-1.786-.902a5.656 5.656 0 00-.926-.078c-.572 0-1.127.205-1.689.205-.079 0-.081-.005-.097-.062-.049-.166-.085-.331-.12-.49-.097-.445-.181-.83-.522-.883-2.182-.337-2.533-.787-2.588-.916A.15.15 0 010 21.81c3.255-.536 4.702-3.795 4.794-4.01.224-.454.263-.857.118-1.2-.258-.607-1.023-.85-1.53-1.011-.116-.037-.216-.068-.293-.099-.658-.26-.86-.522-.83-.68.035-.183.352-.369.629-.369.062 0 .117.01.157.029.449.21.86.317 1.22.317.566 0 .818-.263.845-.293l.061-.069a97.535 97.535 0 00-.045-.763c-.092-1.462-.207-3.281.241-4.286 1.356-3.04 4.229-3.274 5.078-3.274.144.002.291-.002.437-.002" })));
};
var SvgSnapchat = (0, styled_components_1.default)(SVG)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"], ["\n  display: ", ";\n  font-size: ", ";\n  vertical-align: middle;\n  shape-rendering: inherit;\n  transform: translate3d(0, 0, 0);\n"])), function (_a) {
    var _b = _a.display, display = _b === void 0 ? 'inline-block' : _b;
    return display;
}, function (_a) {
    var _b = _a.fontSize, fontSize = _b === void 0 ? '32px' : _b;
    return fontSize;
});
exports.default = SvgSnapchat;
var templateObject_1;
